<div class="bets-wrapper report-wrapper">
  <div class="bets-header">
    <div class="form-and-title">
      <h1>{{ "My Bets" | translate }}</h1>
      <form class="filter-form" [formGroup]="form">
        <mat-form-field appearance="outline" color="primary">
          <mat-select formControlName="status">
            @if (form.value?.period === "CURRENT") {
              @for (option of reportUtils.currentStatuses$ | async; track option) {
                <mat-option [class]="option.value" [value]="option.value">
                  {{ option.label | translate }}
                </mat-option>
              }
            } @else {
              @for (option of reportUtils.pastStatuses$ | async; track option) {
                <mat-option [class]="option.value" [value]="option.value">{{ option.label | translate }}</mat-option>
              }
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" color="primary">
          <mat-select formControlName="period">
            @for (option of reportUtils.periodOptions$ | async; track option) {
              <mat-option [class]="option.value" [value]="option.value">{{ option.label | translate }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" color="primary">
          <mat-select formControlName="RANGE">
            @let dateRangeOptions = reportUtils.dateRangeOptions$ | async;
            @let rangeOptions = dateRangeOptions ?? [];
            @for (type of rangeOptions.slice(0, -1); track type.value) {
              <mat-option [value]="type.value" [disabled]="type.value === 8">{{ type.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </form>
    </div>
    <div class="download-section">
      <span>Download:</span>
      <button class="download-btn text-primary border-primary-2" [disabled]="bets.length === 0" mat-raised-button color="accent" (click)="handleDownload()">
        <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.8125 0.40625V12.5938H10.1875V3.49982L10.0465 3.35974L7.23401 0.547241L7.09393 0.40625H0.8125ZM1.75 1.34375H6.4375V4.15625H9.25V11.6562H1.75V1.34375ZM7.375 2.00018L8.59357 3.21875H7.375V2.00018ZM3.15625 5.09375L4.93787 7.67188L3.15625 10.25H4.28143L5.5 8.46838L6.71857 10.25H7.84375L6.06213 7.67188L7.84375 5.09375H6.71857L5.5 6.87537L4.28143 5.09375H3.15625Z"
            fill="currentColor" />
        </svg>
        {{ "Excel" | translate }}</button
      ><button
        class="download-btn text-primary border-primary-2"
        color="accent"
        [disabled]="bets.length === 0"
        mat-raised-button
        printSectionId="print-section"
        printTitle="My Bets"
        [useExistingCss]="true"
        ngxPrint>
        <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.8125 0.40625V12.5938H10.1875V0.40625H0.8125ZM1.75 1.34375H9.25V11.6562H1.75V1.34375ZM5.22168 3.84863C5.07886 3.8468 4.91223 3.89807 4.79688 3.99512C4.67786 4.09583 4.62476 4.22034 4.5918 4.34668C4.52771 4.59937 4.54602 4.86121 4.60645 5.15234C4.67786 5.49292 4.8811 5.90308 5.0459 6.29492C4.96167 6.65198 4.9397 6.96875 4.81152 7.33496C4.70166 7.6499 4.56067 7.83118 4.43066 8.11133C4.13586 8.22302 3.7843 8.28894 3.55176 8.43359C3.3009 8.58923 3.08118 8.76135 2.95117 9.00488C2.82117 9.24841 2.83582 9.59265 3.00977 9.83984C3.09583 9.96985 3.20935 10.0724 3.36133 10.1328C3.51331 10.1932 3.6781 10.1951 3.81543 10.1475C4.09192 10.0522 4.28784 9.83984 4.47461 9.59082C4.64856 9.36011 4.77124 8.96826 4.92871 8.65332C5.16492 8.57458 5.33521 8.47571 5.58789 8.41895C5.85156 8.36035 6.02917 8.38782 6.27637 8.36035C6.38257 8.4812 6.47229 8.67529 6.58398 8.77051C6.80737 8.9646 7.05273 9.11841 7.3457 9.13672C7.63867 9.15503 7.93164 8.97192 8.09277 8.69727H8.10742V8.68262C8.17883 8.55811 8.22827 8.42261 8.22461 8.27246C8.22095 8.12231 8.14587 7.96484 8.04883 7.8623C7.85657 7.65723 7.61121 7.60413 7.3457 7.56934C7.14062 7.54187 6.85498 7.61511 6.61328 7.62793C6.40088 7.34778 6.19031 7.13721 5.99805 6.77832C5.89368 6.58423 5.86621 6.41943 5.77832 6.22168C5.84607 5.90308 5.97974 5.54785 5.99805 5.26953C6.02002 4.93262 6.0072 4.64148 5.91016 4.37598C5.86072 4.24231 5.78198 4.11047 5.66113 4.00977C5.54395 3.91272 5.39197 3.8523 5.23633 3.84863C5.23083 3.84863 5.22717 3.84863 5.22168 3.84863ZM5.5293 7.32031C5.61353 7.46863 5.7179 7.56201 5.80762 7.70117C5.67578 7.72498 5.57507 7.70117 5.44141 7.73047C5.41943 7.73596 5.40479 7.75427 5.38281 7.75977C5.41028 7.68652 5.44507 7.64258 5.4707 7.56934C5.5 7.48328 5.50183 7.40637 5.5293 7.32031ZM7.25781 8.27246C7.41528 8.2926 7.47205 8.3219 7.49219 8.33105C7.48853 8.33838 7.49768 8.33655 7.49219 8.3457C7.43359 8.44275 7.4281 8.43542 7.38965 8.43359C7.35852 8.43176 7.2395 8.36768 7.12598 8.28711C7.15894 8.28894 7.22852 8.2688 7.25781 8.27246ZM3.97656 9.00488C3.95093 9.04333 3.92896 9.13306 3.90332 9.16602C3.7605 9.35645 3.62866 9.44434 3.5957 9.45898C3.59021 9.45166 3.60486 9.45898 3.5957 9.44434H3.58105C3.53345 9.37659 3.54626 9.40405 3.58105 9.3418C3.61584 9.27954 3.72571 9.1532 3.91797 9.03418C3.93262 9.02502 3.96191 9.01404 3.97656 9.00488Z"
            fill="currentColor" />
        </svg>

        {{ "PDF" | translate }}
      </button>
    </div>
  </div>
  @let loadingCurrent = $loadingCurrent | async;
  @let loadingPast = $loadingPast | async;
<!--  <app-report-loader [show]="(loadingCurrent || loadingPast) && isMyBetsTriggered" />-->
  @if (bets.length === 0 && !loadingCurrent && !loadingPast) {
    <app-alert
      [config]="{
        title: 'No Bets Found.',
        subtitle: 'There are no bets found.',
        type: 'info',
      }" />
  }
  @if (bets.length > 0) {
    <div class="table-scale-container" id="print-section">
      <div class="content table-scaler">
        <table class="bets-table print-table" id="bets-table">
          <thead>
            <tr class="bg-secondary">
              @for (each of filterColumns(columns); track each) {
                @let isDesc = each.title === "Description";
                @let matchesCurrentSort = currentSort?.field === getSortField(each.selector);
                <th
                  [class.cursor-pointer]="!isDesc"
                  (click)="onSort(each.selector)"
                  [matTooltipDisabled]="isDesc"
                  [matTooltip]="matchesCurrentSort ? (currentSort?.order === 'asc' ? 'Sort descending' : 'Clear sorting') : 'Sort ascending'">
                  <div class="b-column">
                    @if (each.title === "Matched Date & Time" && isPast) {
                      @if (isPastSettled) {
                        <span>{{ "Settled Date and Time" | translate }}</span>
                      } @else {
                        <span>{{ "Placed Date and Time" | translate }}</span>
                      }
                    } @else if (each.title === "Odds/Runs") {
                      <span>{{ "Odds" | translate }}/{{ "Runs" | translate }}</span>
                    } @else {
                      <span>{{ each.title | translate }}</span>
                    }
                    <mat-icon [class.hidden]="isDesc" [class.active-sort]="matchesCurrentSort" class="inactive-sort">
                      {{ currentSort && matchesCurrentSort ? (currentSort?.order === "asc" ? "keyboard_arrow_up" : "keyboard_arrow_down") : "unfold_more" }}
                    </mat-icon>
                  </div>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (bet of paginatedBets; track trackBy(bet)) {
              <tr class="bet-item">
                <td>{{ bet?.ID || bet?.customerOrderRef }}</td>
                @if (!isUnmatched && !isPending) {
                  <td>
                    {{ (isPastSettled ? (bet.SETTLED_ON | medium24) : (bet.PLACED_ON | medium24)) || (bet.matchedDate | medium24) || "--" }}
                  </td>
                }
                <td class="desc-td">
                  <div class="text-nowrap">
                    <span>
                      @if (bet?.descriptionPrefix) {
                        <span>{{ bet?.descriptionPrefix }} / </span>
                      }
                      @if (bet?.DESCRIPTION_PREFIX) {
                        <span>{{ bet?.DESCRIPTION_PREFIX }} / </span>
                      }
                      @if (isPast || isPending) {
                        <span class="e-name">{{ bet?.EVENT_NAME || bet?.eventName || "-" }}</span>
                      } @else {
                        @let marketId = isFancyOrBm(bet.descriptionPrefix) ? bet.topic : bet.marketId;
                        <a
                          [routerLink]="[
                            '/app/main',
                            {
                              outlets: {
                                navigation: ['event', bet.eventId],
                                content: ['event-markets', bet.eventId, 'market', marketId],
                              },
                            },
                          ]"
                          >{{ bet?.EVENT_NAME || bet?.eventName || "-" }}</a
                        >
                      }
                      / {{ bet?.MARKET_TYPE || bet?.marketName || "-" }} /
                      {{ bet?.RUNNER_NAME || bet?.runnerName || "-" }}
                    </span>
                    <span>
                      {{ bet?.COMPETITION_NAME || bet?.competitionName || "-" }}
                    </span>
                  </div>
                </td>
                <td>
                  {{ side(bet) | translate }}
                </td>
                <td>
                  {{ bet?.PERSISTENCE_TYPE || bet?.persistenceType | translate }}
                </td>
                <td>
                  {{ betOdds(bet) | number: "1.2-2" }}
                </td>
                <td>
                  {{ betPrice(bet) | number: "1.2-2" }}
                </td>
                <td>
                  {{ displayStake(bet) | number: "1.2-2" }}
                </td>
                @if (!isPastNotSettled) {
                  <td>
                    <b
                      [ngClass]="{
                        lost: bet.RESULT === 'LOST',
                        won: bet.RESULT === 'WON',
                      }">
                      {{ (bet?.PL | number: "1.2-2") || (bet?.profitLoss | number: "1.2-2") }}
                    </b>
                  </td>
                }
                @if (isCurrent) {
                  <td>
                    {{ bet.status === "PENDING" ? bet.status : form.value.status }}
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <mat-paginator
      [length]="totalCount"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="pageSizeOptions"
      (page)="handlePageChange($event)"
      [disabled]="($loadingPast | async) || ($loadingCurrent | async)"
      [showFirstLastButtons]="true"
      aria-label="Select page">
    </mat-paginator>
  }
</div>
